export default __webpack_public_path__ + "static/m-sizzling4-ad4502255fb0dd687a1267179008dc31.jpg";